import type { LiveSensor } from "@/features/deployment-dashboard/live-view/api/live-sensors-response";
import type { SensorMarkerPoint } from "@/features/deployment-dashboard/types";
import {
  worldToFloorplanPixel,
  type WorldToPixelTransformAsset,
} from "@/features/deployment-dashboard/widgets/panels/facility-schematic/services/world-to-pixel-transform";

/**
 * Projects runtime sensors whose parent frame matches the displayed map's
 * calibrated source frame. Sensors in any other frame are omitted rather than
 * being plotted at an incorrect position.
 *
 * This is a coordinate-safety guard only, not an area-ownership check: callers
 * (see `LiveViewContainer`) must already have filtered `sensors` down to the
 * selected area's configured `sensorIds` before calling this, since sensors
 * from a different area can share the same `parent_frame_id`.
 */
export function deriveSensorPoints(
  transform: Pick<WorldToPixelTransformAsset, "sourceFrame" | "matrix"> | undefined,
  sensors: LiveSensor[]
): SensorMarkerPoint[] {
  if (!transform) return [];

  return sensors
    .filter((sensor) => sensor.parent_frame_id === transform.sourceFrame)
    .map((sensor) => ({
      id: sensor.sensor_id,
      name: sensor.sensor_display_name,
      status: sensor.status,
      ...worldToFloorplanPixel(transform, sensor.translation_meters.x, sensor.translation_meters.y),
    }));
}
